import React from 'react'
import { Grid } from '@material-ui/core'

import MainTemplate from '../../templates/MainTemplate'
import DailyMonitoringTemplate from '../../templates/DailyMonitoringTemplate'
import DateInfo from '../../containers/dailyMonitoring/details/main/DateInfo'
import MainSummary from '../../containers/dailyMonitoring/details/main/MainSummary'
import DailyTotals from '../../containers/dailyMonitoring/details/main/DailyTotals/Index'

const DailyMonitoringDetails = (): JSX.Element => {
  return (
    <MainTemplate>
      <DailyMonitoringTemplate>
        <Grid item xs={12}>
          <DateInfo />
        </Grid>
        <Grid item xs={12}>
          <MainSummary />
        </Grid>
        <Grid item xs={12}>
          <DailyTotals />
        </Grid>
      </DailyMonitoringTemplate>
    </MainTemplate>
  )
}

export default DailyMonitoringDetails
